import { render, staticRenderFns } from "./MentorLayout.vue?vue&type=template&id=670b09fd&"
import script from "./MentorLayout.vue?vue&type=script&lang=js&"
export * from "./MentorLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports